import React from 'react';

import { EImageSource } from '@sharedComponents/Images';
import { ReactFCV } from '@types';

import { StyledImage } from './styled';

export const GiftPackagingImages: ReactFCV<{ images: { key: string; url: string }[] }> = ({ images }) => (
  <>
    {images.map((image) => {
      return <StyledImage url={image.url} sourceKey={EImageSource.GIFT_PACKAGING} key={image.key} />;
    })}
  </>
);
